import React from 'react';
import { connect } from 'react-redux';

import { StoreT } from '@global/types.ts';

import getNav from './methods/getNav.ts';

import MobMenuI from './types.ts';

import renderContent from './renders/renderContent.tsx';
import renderHead from './renders/renderHead.tsx';

class MobMenu extends React.Component<MobMenuI['props'], MobMenuI['state']> implements MobMenuI {
    parent: MobMenuI['parent'];

    constructor(props: MobMenuI['props']) {
        super(props);
        this.state = {};

        this.parent = React.createRef();
    }

    getNav = getNav;

    renderHead = renderHead;
    renderContent = renderContent;

    render() {
        const { windowHeight } = this.props;

        return (
            <menu
                ref={this.parent}
                className="publicMobileMenu"
                style={{ height: `${windowHeight}px` }}
            >
                <div
                    className="publicMobileMenu__inner _col"
                    style={{ minHeight: `${windowHeight}px` }}
                >
                    {this.renderHead()}
                    {this.renderContent()}

                    <div className="publicMobileMenu__copy">
                        livecargo CRM 2018-{new Date().getUTCFullYear()} ©
                    </div>
                </div>
            </menu>
        );
    }
}

function mapStateToProps(state: StoreT<'crm'>) {
    return {
        windowHeight: state.windowHeight,
        storePages: state.pages,
        designMode: state.designMode,
    };
}

export default connect(mapStateToProps)(MobMenu);
